<cm-test-container [testCases]="testCases" #testContainer>
    <iframe [src]="$safeUrl()" style="width: 100%; height: 100%" frameborder="0" #configuratorIframe allowfullscreen="true"></iframe
></cm-test-container>
